<template>
  <div class="card shadow mb-4">
    <div v-if="current_page != 'Appliances'" class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 v-if="current_page!='Substations'" class="m-0 font-weight-bold">{{ $t('Energy_usage') }}</h6>
      <h6 v-else class="m-0 font-weight-bold">{{ $t('Load_diagram') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_recent_usage')"></i>
    </div>
    <div class="card-body text-center">
      <LoadingSpinner v-if="loading"></LoadingSpinner>
      <div v-show="!loading" id="canvas-summarychart"></div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'
export default {
  name: 'SummaryChart',
  props: ['consumption_data', 'total_data'],
  components: {
    LoadingSpinner
  },
  data() {
    return {
      chart: null,
      clock: null,
      sec: 0,
      series: {
        battery_charge: {
          name: this.$i18n.t('Battery_charge'),
          translation_key: 'Battery_charge',
          color: '#511461',
          type: 'areaspline',
          fillOpacity: 0.5,
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        },
        battery_discharge: {
          name: this.$i18n.t('Battery_discharge'),
          translation_key: 'Battery_discharge',
          color: '#d433ff',
          type: 'areaspline',
          fillOpacity: 0.5,
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        },
        load: {
          name: this.$i18n.t('Load'),
          translation_key: 'Load',
          color: '#f7882f',
          type: "areaspline",
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        },
        consumption: {
          name: this.$i18n.t('Consumption'),
          translation_key: 'Consumption',
          color: '#f7882f',
          type: "areaspline",
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        },
        production: {
          name: this.$i18n.t('Production'),
          translation_key: 'Production',
          color: '#4187c7',
          type: "areaspline",
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        },
        production_not_used: {
          name: this.$i18n.t('Production_not_used'),
          translation_key: 'Production_not_used',
          color: '#53c8eb',
          type: 'areaspline',
          fillOpacity: 0.3,
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        },
        forecast_consumption: {
          name: this.$i18n.t('Forecast_consumption'),
          translation_key: 'Forecast_consumption',
          color: '#c96c21',
          type: 'areaspline',
          //fillOpacity: 0.3,
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        },
        forecast_production: {
          name: this.$i18n.t('Forecast_production'),
          translation_key: 'Forecast_production',
          color: '#295a87',
          type: 'areaspline',
          //fillOpacity: 0.3,
          tooltip: {
            valueSuffix: ' W',
            valueDecimals: 2
          },
          data: []
        }
      }
    }
  }, 
  mounted: function(){
    const self = this
    const chart_options =  {
      chart: {
        zoomType: '',
        backgroundColor: '#fff',
      },
      title: {
        text: null
      },
      credits: { enabled: false },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          day: '%a, %e %b'
        }
      },
      yAxis: [{
        title: {
          text: ''
        },
        maxPadding: 0.5,
        endOnTick: false
      }],
      legend: {
        enabled: true
      },
      tooltip: {
        shared: true,
        valueDecimals: 0,
        /* pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b> W', */
        xDateFormat: '%A, %d %b, %H:%M',
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false
          },
          events: {
            legendItemClick: function () {
              if (this.visible) _paq.push(['trackEvent', 'Geral', 'Gráfico Resumo', 'Esconder (' + this.name + ')'])                        
              else _paq.push(['trackEvent', 'Geral', 'Gráfico Resumo', 'Mostrar (' + this.name + ')'])
            },
            mouseOver: function () {
              self.clock = setInterval(function(){ self.sec++; }, 1000)
            },
            mouseOut: function () {
              clearInterval(self.clock);
              if (self.sec > 1) _paq.push(['trackEvent', 'Geral', 'Gráfico Resumo', 'MouseOver (' + this.name + ')', self.sec])
              self.sec = 0
            }
          }
        },
      },
      series: [/* {
        name: this.$i18n.t('Consumption'),
        color: '#f7882f',
        type: "areaspline",
        tooltip: {
          valueSuffix: ' W',
          valueDecimals: 2
        },
        data: []
      },
      {
        name: this.$i18n.t('Production'),
        color: '#4187c7',
        type: "areaspline",
        tooltip: {
          valueSuffix: ' W',
          valueDecimals: 2
        },
        data: []
      },
      {
        name: this.$i18n.t('Production_not_used'),
        color: '#53c8eb',
        type: 'areaspline',
        fillOpacity: 0.3,
        tooltip: {
          valueSuffix: ' W',
          valueDecimals: 2
        },
        data: []
      } */]
    };
    if (this.$route.name == "Appliances") chart_options.series.splice(1, 1)
    this.chart = Highcharts.chart('canvas-summarychart', chart_options)
  },
  methods: {
    set_values: function(){
      const timezone = this.timezone
      if (this.range != "next_hours")
        if (!this.data.data || !this.data.data.summaryChart || !this.data.data.summaryChart.length) {
          for (let i=0; i<this.chart.series.length; i++) {
            if (this.chart.series[i])
              this.chart.series[i].setData([])
          }
          return 
        }

      if (this.current_page != "Appliances") {
        this.remove_all_series()
        if (this.current_page != "Substations") this.add_series(this.series.consumption)
        else this.add_series(this.series.load)
        this.chart.series[0].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.House!=null ? Math.round(Math.max(r.House, 0)) : null]), false)
        
        // If UPAC has battery
        if (this.has_battery) {
          this.add_series(this.series.battery_charge)
          this.add_series(this.series.battery_discharge)
          this.chart.series[1].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV_Batt + r.Grid_Batt]), false)
          this.chart.series[2].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.Batt_House + r.Batt_Grid]), false)
          if (this.current_page != "Substations" || this.selected_group._id != "5b54644d8989cd324decc59e") {
            this.add_series(this.series.production)
            this.add_series(this.series.production_not_used)
            this.chart.series[3].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV!=null ? Math.round(Math.max(r.PV, 0)) : null]), false)
            this.chart.series[4].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV_Grid]), false)
          }
        } 
        else {
          this.add_series(this.series.production)
          this.add_series(this.series.production_not_used)
          this.chart.series[1].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV!=null ? Math.round(Math.max(r.PV, 0)) : null]), false)
          this.chart.series[2].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV_Grid]), false)
        }
        // If UPAC has FORECAST
        if (this.user_is_admin && this.current_page != "Substations" && this.group_forecasts.length) {
          for (let f of this.data.forecasts){
            this.add_series(this.series[f.type])
            this.chart.series[this.chart.series.length-1].setData(f.summaryChart.map(r => {
              let value = null
              if (f.type == "forecast_consumption") value = r.measure_cons || r.House || r.consumption || r.forecast_consumption
              else if (f.type == "forecast_production") value = r.measure_prod || r.PV || r.production || r.forecast_production
              return [moment.tz(r.datetime, timezone).valueOf(), value!=null ? Math.round(value) : null]
            }
            ), false)
          }
        }
        // Wastings
        //this.chart.series[2].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.production > r.consumption ? r.production - r.consumption : 0 ]), false)
        //this.chart.series[2].setData(this.data.data.summaryChart.map(r => [moment.tz(r.datetime, timezone).valueOf(), (r.production - r.consumption + r.battery) > 0 ? (r.production - r.consumption + r.battery) : 0 ]), false)
      }
      // Appliances page
      else { 
        this.remove_all_series()
        this.add_series(this.series.consumption)
        this.add_series(this.series.production_not_used)
        if (this.consumption_data && this.consumption_data.length)
          this.chart.series[0].setData(this.consumption_data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.House]), false)
        else this.chart.series[0].setData([], false)
        
        if (this.total_data && this.total_data.length)
          this.chart.series[1].setData(this.total_data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV_Grid ]), false)
      }
      if (!this.chart.hasData()) {
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t("No_Data"))
      }
      this.chart.redraw()
    },
    add_battery_series: function(){
      if (this.chart.yAxis.length == 2) this.chart.yAxis[1].remove()
      if (this.chart.yAxis.length == 1) {
        this.chart.addAxis({
          id: 'battery-axis',
          title: {
            text: this.$i18n.t('Battery')+' (%)'
          },
          lineWidth: 0,
          min: 0,
          max: 100,
          opposite: true,
          endOnTick: false,
          maxPadding: 0.5
        })
      }
      if (this.chart.series.length == 3) {
        this.data.batteries.forEach(b => {
          this.chart.addSeries({ 
            name: `${this.$i18n.t('Battery_occupation')} ${b.name}`, 
            color: "#1cc88a", 
            yAxis: "battery-axis", 
            type:"spline",
            tooltip: {
              valueSuffix: ' %',
              valueDecimals: 0
            },
            data: b.summaryChart.length ? b.summaryChart.map(r => [moment.tz(r.datetime, this.timezone).valueOf(), r.battery_capacity]) : []
          })
        })
      }
    },
    remove_battery_series: function(){
      if (this.chart.series.length >= 4) {
        for (let i=3; i<this.chart.series.length; i++) {
          this.chart.series[i].remove()
        }
      } 
      if (this.chart.yAxis.length == 2)
        this.chart.yAxis[1].remove()
    },
    remove_series: function(i){
      this.chart.series[i].remove()
    },
    remove_all_series: function() {
      while (this.chart.series.length > 0) 
        this.chart.series[0].remove()
    },
    add_series: function(series) {
      series.name = this.$i18n.t(series.translation_key)
      this.chart.addSeries(series)
    }
  },
  watch: {
    data: function(){
      this.set_values()
    },
    consumption_data: function(){
      //if (this.consumption_data.length)
      this.set_values()
    },
    current_lang: function(){
      this.chart.series[0].update({name: this.$i18n.t('Consumption')}, false);
      if (this.current_page == "Appliances") this.chart.series[1].update({ name: this.$i18n.t('Production_not_used') }, false);
      else {
        this.chart.series[1].update({ name: this.$i18n.t('Production') }, false);
        this.chart.series[2].update({ name: this.$i18n.t('Production_not_used') }, false);
      }
      this.set_values()
    }
  },
  computed: {
    data: function() {
      return this.$store.getters.data.length ? this.$store.getters.data[0] : {}
    },
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      return this.$store.getters.user_bess
    },
    has_forecast: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_forecast
      return this.$store.getters.user_forecast
    },
    group_forecasts: function() {
      return this.$store.getters.group_forecasts
    },
    is_total_group_selected: function(){
      let total_group_id = null
      if (this.$store.getters.user_isAdmin) total_group_id = this.$store.getters.remote_user_total_group_id(this.$store.getters.selected_producerId)
      else total_group_id = this.$store.getters.user_total_group_id
      const selected_groupId = this.$store.getters.selected_groupId
      return selected_groupId == total_group_id
    },
    selected_producerId: function(){
      return this.$store.getters.selected_producerId
    },
    selected_group: function(){
      const selected_group_id = this.$store.getters.selected_groupId
      const selected_producerId = this.$store.getters.selected_producerId
      let selected_group = null
      if (this.$store.getters.user_isAdmin) 
        selected_group = this.$store.getters.remote_user_group(selected_producerId, selected_group_id)
      else selected_group = this.$store.getters.user_group(selected_group_id)
      return selected_group
    },
    user_is_admin: function(){
      return this.$store.getters.user_isAdmin
    },
    loading: function(){
      //if (this.current_page == "Substations") return false
      return this.$store.getters.data_loading
    },
    range: function(){
      return this.$store.getters.selected_range
    },
    current_page: function(){
      return this.$route.name
    },
    current_lang: function(){
      return this.$i18n.locale
    },
    timezone: function(){
      return this.$store.getters.timezone
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>